//A simple button component 

import React from 'react';
import { StyledGridButton } from './GridButton.styled';
import { IButtonProps } from '../../Button/Button';

//Mostly the same as a normal button but adds some styling (see .styled)
export const GridButton: React.FC<IButtonProps> = (props) => {
  return <StyledGridButton {...props}/>
}